import { useCallback, useEffect, useRef } from 'react'
import { Col } from 'react-bootstrap'
import { useMediaQuery, useMountEffect } from '@react-hookz/web'
import clsx from 'clsx'
import { debounce } from 'lodash-es'

import { PORTAL_BREAKPOINTS } from 'Constants/constants'

import { ContentSidebarProps } from './ContentSidebar.types'

export const ContentSidebar = (props: ContentSidebarProps) => {
  const { children, isPreviewColumnShown, renderStickyColumnSideContent } =
    props
  const scrollAreaRef = useRef<HTMLDivElement>(null)
  const isDesktop = useMediaQuery(`(min-width: ${PORTAL_BREAKPOINTS.XXL})`)

  const updateScrollAreaHeight = useCallback(() => {
    const { current: scrollArea } = scrollAreaRef

    if (!scrollArea) {
      return
    }

    const { top } = scrollArea.getBoundingClientRect()

    scrollArea.style.height = `${window.innerHeight - top}px`
  }, [])

  useMountEffect(() => {
    updateScrollAreaHeight()
  })

  useEffect(() => {
    const debouncedUpdateScrollAreaHeight = debounce(
      updateScrollAreaHeight,
      250,
    )

    window.addEventListener('resize', debouncedUpdateScrollAreaHeight)

    return () => {
      window.removeEventListener('resize', debouncedUpdateScrollAreaHeight)
    }
  }, [updateScrollAreaHeight])

  useEffect(() => {
    const debouncedUpdateScrollAreaHeight = debounce(
      updateScrollAreaHeight,
      500,
    )

    window.addEventListener('scroll', debouncedUpdateScrollAreaHeight)

    return () => {
      window.removeEventListener('scroll', debouncedUpdateScrollAreaHeight)
    }
  }, [updateScrollAreaHeight])

  return (
    <Col
      className="ContentSidebar d-none d-lg-block position-relative"
      xl={12}
      xxl={4}
    >
      {renderStickyColumnSideContent && (
        <div className="sticky-column">
          <div className="position-absolute">
            <div ref={scrollAreaRef} className="ContentSidebar-scroll-area">
              {renderStickyColumnSideContent}
            </div>
          </div>
        </div>
      )}
      <div
        className={clsx(
          'ContentSidebar-preview-column',
          isDesktop && 'sticky-column',
          isPreviewColumnShown
            ? 'sticky-column--preview'
            : 'ContentSidebar-preview-column--is-closed',
        )}
      >
        <div>{children}</div>
      </div>
    </Col>
  )
}
